<template>
  <div>
    <template_1 v-if="id == 1" :data="data"></template_1>
    <template_2 v-if="id == 2" :data="data"></template_2>
    <template_3 v-if="id == 3" :data="data"></template_3>
  </div>
</template>

<script>
import template_1 from '../components/template-1.vue'
import template_2 from '../components/template-2.vue'
import template_3 from '../components/template-3.vue'
export default {
  name: 'home',
  components: {
    template_1,
    template_2,
    template_3,
  },
  data() {
    return {
      id: '',
      data: ''
    }
  },
  created(){
    let data = this.$route.query
    this.id = data.id
    this.data = this.$route.query
  }
}
</script>
